import React from "react";
import Lottie from "react-lottie";
import * as animationData from "../../animations/14579-process.json";
const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData: animationData.default,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};

export default function EmptyFavoritesAnimation() {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <Lottie options={defaultOptions} height={300} width={300} />
    </div>
  );
}
